// Simple feature flag to enable/disable ads across the site
// Usage:
//   - In production, set REACT_APP_ENABLE_ADS=true to enable ads
//   - Defaults to false when the env var is not provided (safer default)

export const ADS_ENABLED = (() => {
  const value = (process.env.REACT_APP_ENABLE_ADS || 'false').toString().toLowerCase();
  return value === 'true' || value === '1' || value === 'yes';
})();


